import { Spin } from "antd";

export const LoadingPage = () => {
  return (
    <div className="w-screen h-screen bg-white flex justify-center items-center">
      <Spin size="large" />
    </div>
  );
};
